import { render, staticRenderFns } from "./Recorddece.vue?vue&type=template&id=fa3ed92a&scoped=true"
import script from "./Recorddece.vue?vue&type=script&lang=js"
export * from "./Recorddece.vue?vue&type=script&lang=js"
import style0 from "./Recorddece.vue?vue&type=style&index=0&id=fa3ed92a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3ed92a",
  null
  
)

export default component.exports